<div class="conteneur" *ngIf="preinscriptions; else loader">

  <mat-card appearance="outlined" *ngIf="config && config.infoMessageList" style="margin: 5px;"
    [portailCustomStyle]="config.styleCardInfoList">
    <div [innerHtml]="config.infoMessageList | safe"></div>
  </mat-card>

  <div class="preinscription-list">

    <mat-card appearance="raised" class="preinscription-card" *ngFor="let preinscription of preinscriptions">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <mat-icon *ngIf="preinscription.idAdulte" style="margin-right: 5px;">person</mat-icon>
          <app-icon *ngIf="preinscription.idEnfant" style="margin-right: 5px;" type="do" icon="enfant"></app-icon>
          <span>{{ preinscription.nom }} {{ preinscription.prenom }}</span>
        </mat-card-title>
        <button *ngIf="permToEdit" mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </mat-card-header>

      <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item (click)="onClickEdit(preinscription)">
          <mat-icon color="primary">edit
          </mat-icon>
          {{ 'action.see_edit'|trans }}
        </button>
      </mat-menu>

      <mat-card-content>

        <app-status-bar [decision]="preinscription.decision" [motifRefus]="preinscription.motifRefus"
          [motifAbandon]="preinscription.motifAbandon" />

        <div class="info-grid">
          <div class="info-item full-width">
            <span class="info-label">{{ 'lasido.date_demande'|trans }}</span>
            <span class="info-value">{{ preinscription.dateDemande ? (preinscription.dateDemande|date:'shortDate') : ''
              }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ 'lasido.annee_scolaire'|trans }}</span>
            <span class="info-value">{{ preinscription.anneeScolaireName }}</span>
          </div>
          @if(preinscription.accueilName){
          <div class="info-item">
            <span class="info-label">Etablissement - Accueil</span>
            <span class="info-value">
              @if(preinscription.etablissementName){
              {{ preinscription.etablissementName }} -
              }
              {{ preinscription.accueilName }}
            </span>
          </div>
          }

          @if(preinscription.choiceGroups?.length){
          <div class="info-item full-width">
            <span class="info-label">{{ 'lasido.souhaits'|trans }}</span>
            @for (choice of preinscription.choiceGroups; track choice; let i = $index) {
            <div class="souhait-item fx-direction-col fx-gap-5">
              <div class="fx-direction-row fx-between-center">
                <div class="fx-direction-row fx-gap-5 fx-start-center">
                  <span class="numero">{{i + 1}}</span>
                  <div style="font-weight: 500;font-size: 15px;">
                    <span *ngIf="choice.departementName">
                      {{ choice.departementName }}<span class="separator">-</span>
                    </span>
                    <span>{{ choice.disciplineName }}<span class="separator">-</span></span>
                    <span>{{ choice.niveauName }}</span>
                  </div>
                </div>
                <app-icon *ngIf="choice.decision === 'Refusée'" type="fa" icon="times-circle" class="icon-decision warn"
                  matTooltip="Refusée"></app-icon>
                <app-icon *ngIf="choice.decision === 'Acceptée'" type="fa" icon="check-circle"
                  class="icon-decision success-color" matTooltip="Acceptée"></app-icon>
                <app-icon *ngIf="choice.decision === 'Abandon'" type="fa" icon="trash" class="icon-decision"
                  matTooltip="Abandon">
                </app-icon>
                <app-icon *ngIf="choice.decision === 'En attente' || choice.decision === ''" type="fa"
                  icon="question-circle" class="icon-decision accent" matTooltip="En attente"></app-icon>
              </div>

              <div class="cours-list">
                @for (cours of choice.cours; track cours; let i = $index) {
                <div class="cours-block" [ngClass]="{'bg-cours-retenu': cours.isCoursRetenu}">
                  <div class="fx-direction-row fx-between-center">
                    <div class="fx-direction-row fx-gap-5 fx-start-center">
                      <span class="numero">{{i + 1}}</span>
                      <span class="cours-label">{{ cours.name }}</span>
                    </div>
                    @if(cours.isCoursRetenu){
                    <app-icon type="fa" icon="check-circle" class="icon-decision success-color"
                      matTooltip="Cours retenu"></app-icon>
                    }
                  </div>
                  <div class="details-cours-block">
                    <div class="details-cours">
                      <label>Horaire : </label>
                      <span *ngIf="!cours.provisoire; else coursProvisoire">Le {{cours.jour}}
                        de
                        {{cours.heureDebut}} à
                        {{cours.heureFin}}</span>
                    </div>
                    <ng-template #coursProvisoire>
                      <span>{{'lasido.text-cours-provisoire' | trans}}</span>
                    </ng-template>

                    <div class="details-cours">
                      <label>Enseignant(s) : </label>
                      <span *ngFor="let enseignant of cours.enseignants; let last = last" style="margin-right: 5px;">
                        {{enseignant.nomPrenom}}{{!last ? ' - ' : ''}}
                      </span>
                    </div>
                    @if(cours.salle){
                    <div class="details-cours">
                      <label>Salle : </label>
                      <span>{{cours.salle}}</span>
                    </div>
                    }
                    <div class="details-cours">
                      <label>Type : </label>
                      <span>{{cours.individuel ? 'Individuel' : 'Collectif'}}</span>
                    </div>
                  </div>
                </div>
                }
              </div>

            </div>
            }
          </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card appearance="outlined" *ngIf="permToCreate" class="actions-card card-add">
    <mat-card-header class="fx-direction-row fx-center-center">
      <mat-card-title class="fx-direction-row fx-center-center">
        {{ 'lasido.new_preinscription'|trans }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="fx-direction-row fx-center-center" style="padding-top: 16px;">
      <button mat-fab color="primary" matTooltip="{{ 'lasido.new_preinscription'|trans }}" [disabled]="!addBtnUrl"
        [routerLink]="addBtnUrl">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>

  <div *ngIf="!preinscriptions.length && !permToCreate">
    <h2 style="text-align: center;">Vous n'avez pas de pré-inscription(s).</h2>
  </div>

</div>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>